module.exports = __webpack_public_path__ + "static/media/bg_bottom.e9b21786.svg";